<template>
  <custom-form
    :id="id"
    :item="item"
    redirect="show_this"
    :parentResource="parentRes"
    :parentResourceId="parent.id"
  >
    <v-row justify="center">
      <v-col sm="8">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2">
              {{ title }}
            </div>
          </template>
          <v-card-text>
            <va-hidden-input
              v-if="parentRes == 'stat_sections' && section"
              type="hidden"
              source="stat_section_id"
              :value="section.id"
            ></va-hidden-input>
            <va-hidden-input
              v-if="parentRes == 'stat_question_sections' && epigraph"
              type="hidden"
              source="stat_question_id"
              :value="epigraph.id"
            ></va-hidden-input>
            <va-hidden-input
              type="hidden"
              source="type"
              :value="type"
            ></va-hidden-input>
            <va-text-input source="title"></va-text-input>
            <va-text-input source="summary" multiline></va-text-input>
            <va-boolean-input source="not_available"></va-boolean-input>
          </v-card-text>
          <va-save-button></va-save-button>
        </base-material-card>
      </v-col>
      <v-col cols="3">
        <v-card class="mt-8">
          <v-list color="transparent" subheader>
            <v-subheader>Detalles</v-subheader>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-chart-line</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-wrap font-weight-bold text-uppercase"
                  >
                    {{ section.stat.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-chart-box-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-wrap font-weight-bold text-uppercase"
                  >
                    {{ section.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="epigraph">
                <v-list-item-icon>
                  <v-icon>mdi-format-list-checks</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-wrap font-weight-bold text-uppercase"
                  >
                    {{ epigraph.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </custom-form>
</template>

<script>
export default {
  props: ["title", "id", "item", "parent", "parentRes", "epigraph", "section"],
  data() {
    return {
      type: "question",
    };
  },
};
</script>
